import { API } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function validateAffectedStaffsSalaries(ids: number[]) {
  return restApiClient.url(API.affectedStaffs.validateAffectedStaffsSalaries.url).post({ ids })
}
